// extracted by mini-css-extract-plugin
export default {"dropdown":"search-dropdown__dropdown___G1IK4","loader":"search-dropdown__loader___LBGkR"};